import script from "./SalesOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./SalesOverview.vue?vue&type=script&setup=true&lang=js"

import "./SalesOverview.vue?vue&type=style&index=0&id=0c5b148c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c5b148c"]])

export default __exports__